import { PageAddListingContextProvider } from "application/contexts/AddItemContext/PageAddListingContext";
import { Page } from "navigation/types";
import { Route, Routes } from "react-router-dom";
import PageAddExperience1 from "containers/AddListingFlows/PageAddExperience/PageAddExperience";
import PageAddExperience2 from "containers/AddListingFlows/PageAddExperience/PageAddExperience2";
import PageAddExperience3 from "containers/AddListingFlows/PageAddExperience/PageAddExperience3";
import PageAddExperience4 from "containers/AddListingFlows/PageAddExperience/PageAddExperience4";
import PageAddExperience5 from "containers/AddListingFlows/PageAddExperience/PageAddExperience5";
import { StockNumericType } from "data/enums";
import PageAddListingBorgoIntro from "containers/AddListingFlows/InFlowBorgoCreation/PageAddListingBorgoIntro";
import PageAddListingBorgo from "containers/AddListingFlows/InFlowBorgoCreation/PageAddListingBorgo";

const AddExperiencePages: Page[] = [
  { path: "/add-listing-1", component: PageAddExperience1 },
  { path: "/add-listing-2", component: PageAddExperience2 },
  { path: "/add-listing-3", component: PageAddExperience3 },
  { path: "/add-listing-4", component: PageAddExperience4 },
  { path: "/add-listing-5", component: PageAddExperience5 },
  { path: "/add-listing-borgo-intro", component: () => <PageAddListingBorgoIntro 
      indexPage="02a" backHref="/host/new-experience/add-listing-2" nextHref="/host/new-experience/add-listing-borgo"
    />
  },
  { path: "/add-listing-borgo", component: () => <PageAddListingBorgo
      indexPage="02b" backHref="/host/new-experience/add-listing-borgo-intro" nextHref="/host/new-experience/add-listing-3" sourceFlow={StockNumericType.EXPERIENCE}
    /> 
  }
]

const AddExperiencePagesRouter = () => {
  return (
    <PageAddListingContextProvider>
      <Routes>
        {AddExperiencePages.map(({ component, path }) => {
          const Component = component;
          return <Route key={path} element={<Component />} path={path} />;
        })}
      </Routes>
    </PageAddListingContextProvider>

  )
}

export default AddExperiencePagesRouter;